import { ReplacementProcessListResponse } from '@/types/service-response'

export class Replacement {
  public constructor (
    readonly id: number,
    readonly fullName: string,
    readonly shortName: string,
    readonly employeeId: number,
    readonly personalNumber: string,
    readonly addressName: string,
    readonly addressNumber: string,
    readonly addressId: number,
    readonly dateTo: string,
    readonly dateFrom: string,
    readonly absenceReason: number,
    readonly STVSpecification: string,
    readonly email: string,
    readonly phone: string,
    readonly absenceId: number,
    readonly groupLabel: string,
    readonly addressLabel: string
  ) {}

  static createFromResponse (responseData: ReplacementProcessListResponse[]): Array<Replacement> {
    let result: Array<Replacement> = []
    if (responseData) {
      result = responseData.map((item: ReplacementProcessListResponse, idx) => {
        const groupLabel: string = `${item.Kurzzeichen} / ${item.FullName} (${item.PersonalNummer})`
        const addressLabel: string = `${item.AdressNummer} ${item.AdressLinie}`
        return new Replacement(
          idx,
          item.FullName ? item.FullName : '',
          item.Kurzzeichen ? item.Kurzzeichen : '',
          item.M_ID,
          item.PersonalNummer ? item.PersonalNummer : '',
          item.AdressLinie ? item.AdressLinie : '',
          item.AdressNummer ? item.AdressNummer : '',
          item.AdressID,
          item.DatumBis,
          item.DatumVon,
          item.Grund,
          item.STV_Vorgabe ? item.STV_Vorgabe : '',
          item.M_Email ? item.M_Email : '',
          item.M_Phone ? item.M_Phone : '',
          item.AbwesenheitenID,
          groupLabel,
          addressLabel
        )
      })
    }
    return result
  }
}
